import { createContext, useContext } from 'react';
export const BiContext = createContext(undefined);
export function useBi() {
    const context = useContext(BiContext);
    if (context === undefined) {
        throw new Error('useBi must be used within a BiProvider');
    }
    return context;
}

//# sourceMappingURL=bi-context.js.map